import React, { useState } from 'react';
import { Td, Tr, TrPlaceholder, TrLoader, RenderData } from '@oforce/global-components';
import { Table } from '../../../components/table-2.0';
import { TrGraphQLErrors } from '../../../components';
import { CustomInput } from 'reactstrap';

export default function BulkEmailInsuredsTable({ formik, insureds, loading, error }) {
  const colSpan = 3;
  const { insuredIdsFilteredByDocs } = formik?.values;
  const initialToggleState = !!insuredIdsFilteredByDocs.length;
  const [selectAll, setSelectAll] = useState(initialToggleState);

  const toggleSelectAll = selectAll => {
    !selectAll
      ? formik?.setFieldValue('insuredIds', insuredIdsFilteredByDocs)
      : formik?.setFieldValue('insuredIds', []);
    setSelectAll(!selectAll);
  };

  return (
    <Table responsive>
      <thead>
        <tr>
          <th>
            <CustomInput
              id="toggleSelectAllInsuredIds"
              type="checkbox"
              checked={selectAll}
              onChange={() => toggleSelectAll(selectAll)}
              className="mb-1"
            />
          </th>
          <th>Insured</th>
          <th>Email</th>
        </tr>
      </thead>
      <tbody>
        <RenderData
          data={insureds}
          loading={loading}
          error={error}
          loadingComponent={<TrLoader colSpan={colSpan} />}
          errorComponent={<TrGraphQLErrors colSpan={colSpan} error={error} />}
          placeholderComponent={<TrPlaceholder colSpan={colSpan}>No insureds</TrPlaceholder>}
          style={{ border: '0px!important' }}
        >
          {insureds =>
            insureds?.map(insured => (
              <Tr
                key={insured?.id}
                style={formik?.values?.insuredIds.includes(insureds?.id) ? { backgroundColor: '#e6eaf2' } : {}}
              >
                <Td>
                  <CustomInput
                    id={insured?.id}
                    type="checkbox"
                    checked={formik?.values?.insuredIds.includes(insured?.id) && !!insured?.email}
                    disabled={!insured?.email}
                    onChange={() => {
                      if (formik?.values?.insuredIds?.includes(insured?.id)) {
                        formik?.setFieldValue(
                          'insuredIds',
                          formik?.values?.insuredIds.filter(insuredId => insuredId !== insured?.id)
                        );
                      } else {
                        formik?.setFieldValue('insuredIds', [...formik?.values?.insuredIds, insured?.id]);
                      }
                    }}
                  />
                </Td>
                <Td>
                  {insured?.firstName} {insured?.lastName}
                </Td>
                <Td>{insured?.email}</Td>
              </Tr>
            ))
          }
        </RenderData>
      </tbody>
    </Table>
  );
}
